export default __webpack_public_path__ + "static/media/mapa.25a41a7a.png";